jQuery(function($) {


  // Admin truc //
  jQuery('.rm_section .rm_options').hide();
  jQuery('.rm_section h3').click(function(){        
      if(jQuery(this).parent().next('.rm_options').css('display')==='none')  
          {   jQuery(this).removeClass('inactive').addClass('active').children('img').removeClass('inactive').addClass('active');  
                
          }  
      else  
          {   jQuery(this).removeClass('active').addClass('inactive').children('img').removeClass('active').addClass('inactive');  
          }  
            
      jQuery(this).parent().next('.rm_options').slideToggle('slow');    
  });  


  // MENU RESPONSIVE //

  // en attendant, on ajoute les class en js :/
  //$( '#site-navigation' )

    var btn = '<button class="dl-trigger">Open Menu</button>';
    $( '#dl-menu' ).prepend(btn);
    $( '.sub-menu' ).addClass('dl-submenu');
    

  //0. On active le menu sur la div au dessus du menu
      var $menu_mobile = $( '#dl-menu' ).dlmenu();
      var $ul_big_menu = $('#dl-menu > ul');

      function activation_menu_mobile(){
         if(!$( "#dl-menu > ul .reu" ).length){
          var $add_li_btn_mobile = $('#menu_rac_right ul').html();
          $ul_big_menu.prepend($add_li_btn_mobile);
        }

        //console.log($( '#dl-menu' ).init);
        $('.t_first_li').css('display', 'none');

        $ul_big_menu.attr("class","dl-menu");
        console.log('Activation menu');
      }

      function desactivation_menu_mobile(){
         if($( "#dl-menu > ul .add_tomenu" ).length){
          $( "#dl-menu > ul .add_tomenu" ).remove();
        }

        $('.t_first_li').css('display', 'block');

        $ul_big_menu.attr("class","");
        console.log('Désactivation menu');
      }

      function active_or_not_menu_mobile(){
        wwStart = $( window ).width();
        if (wwStart <= 700){
          activation_menu_mobile();
        }else {
          desactivation_menu_mobile();
        }
      }

      active_or_not_menu_mobile();
      // init activation or not
    

      $( window ).on( "resize", function() {
        active_or_not_menu_mobile();
        col_aside_fixe_or_not();
        });


function col_aside_fixe_or_not(){
  var aside = $("#secondary");
  var l_window = $(window).width();
  var l_content = $("#primary").outerWidth()+260;
 
  if (l_window > 1300){
    aside.addClass('fixed');
    aside.css({'width':parseInt(l_window-l_content), 'top':115});
  }else{
    aside.removeClass('fixed');
    aside.css({'width':'inherit', 'top':'inherit'});

  }
}

  col_aside_fixe_or_not();


  });